import React from "react";
import { FIRMS } from "../../consts/tables";
import FirmInfo from "./FirmInfo";
import CRUD from "../CRUD";
import { getCurrentAccess } from "../../access";
import { editsEverySummitRecord } from "../../access-levels";
import { browserHistory } from "react-router";
import { getData } from "../../requests/CRUD";
import { saveFirmRow, CRM_CREATE_DUPLICATE } from "../../requests/firms";
import { executeBackendQuery } from "../../requests/executeBackendQuery";
import { FIRM_ATTACHED_PEOPLE } from "../../consts/queries";

export default class CRUDFirm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      errorTabs: [],
      currentTab: 0,
      viewMode: this.props.edit || false,
      people: [],
      peopleBusy: false,
      peopleError: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.saveData = this.saveData.bind(this);
    this.persist = this.persist.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
    }
  }

  componentDidMount() {
    this.fetch(this.props.params.id);
  }

  fetch(id) {
    this.setState({
      data: null,
      error: null,
      success: null,
      people: [],
      peopleError: null,
    });

    if (id === undefined) {
      this.setState({
        data: {},
      });
      return;
    }

    getData({
      tableCode: FIRMS,
      options: {
        filter: [
          {
            text: id,
            code: "ARCIMEDES_ROW_ID",
            type: "exact",
          },
        ],
      },
    }).then((res) => {
      if (res && res.success && Array.isArray(res.data) && res.data.length) {
        this.setState({
          data: res.data[0],
          original: { ...res.data[0] },
          error: null,
        }, () => this.fetchAttachedPeople(id));
      } else {
        this.setState({
          data: false,
          error: res.message ? res.message : "Unidentified Error",
        });
      }
    });
  }

  /**
   * The investors, agents and vendors this firm is attached to. A firm can be
   * deleted from this screen, which leaves them pointing at one that is gone,
   * so the roster is shown alongside the form rather than found out afterwards.
   */
  fetchAttachedPeople(id) {
    this.setState({ peopleBusy: true, peopleError: null });

    return executeBackendQuery({
      queryName: FIRM_ATTACHED_PEOPLE,
      params: { FIRM_ID: String(id) },
    }).then(
      (res) => {
        if (res && res.success && Array.isArray(res.data)) {
          this.setState({ people: res.data, peopleBusy: false });
        } else {
          this.setState({
            people: [],
            peopleBusy: false,
            peopleError: "Could not load the people attached to this firm.",
          });
        }
      },
      () => {
        this.setState({
          people: [],
          peopleBusy: false,
          peopleError: "Could not load the people attached to this firm.",
        });
      }
    );
  }

  handleSubmit(e) {
    e.preventDefault();

    if (this.state.viewMode) this.setState({ viewMode: false });

    if (this.state.isBusy || this.state.viewMode === true) return;

    this.setState({ viewMode: true }, () => this.saveData());
  }

  handleChange(key, value) {
    this.setState({
      data: Object.assign(this.state.data, {
        [key]: value,
      }),
    });
  }

  handleChangeDropdown(query, queryType, x, key) {
    this.setState({
      data: Object.assign(this.state.data, {
        [key]: query[key],
      }),
    });
  }

  /**
   * The prop CRUD calls, which passes its own arguments (CRUD.js calls
   * `saveData(data)` on the delete toggle). It takes none of them: a stray
   * truthy argument must never stand in for the user's answer below.
   */
  saveData() {
    return this.persist(false);
  }

  persist(confirmCrmCreate) {
    if (this.state.isBusy) return;

    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });

    return saveFirmRow(this.state.data, { confirmCrmCreate }).then(
      (res) => {
        // This firm has no CRM record, and one of ours is already linked under
        // the same name. Kore cannot be searched, so only the user can say
        // whether to create a second organization.
        if (res && !res.success && res.confirm === CRM_CREATE_DUPLICATE) {
          this.setState({ isBusy: null, viewMode: false }, () => {
            if (window.confirm(res.message)) this.persist(true);
          });
          return;
        }

        if (res && res.success) {
          const saved = (res.data || [])[0];

          this.setState(
            {
              isBusy: false,
              success: "Saved",
              // The save can give the firm a new Kore organization; the next save sends this row back.
              data: saved ? { ...this.state.data, CRM_ID: saved.CRM_ID } : this.state.data,
            },
            () => {
              if (!this.props.edit) {
                browserHistory.push({
                  pathname: `/firm/${res.data[0].ARCIMEDES_ROW_ID}`,
                });
              }
            }
          );

          window.scrollTo(0, 0);
        } else {
          this.setState({
            isBusy: null,
            error: res && res.message ? res.message : "Unspecified error",
          });
        }
      }
    );
  }

  render() {
    const data = this.state.data;
    const { edit } = this.props;

    return (
      <CRUD
        tabsData={[
          {
            name: "FIRM",
            renderedComponent: (
              <FirmInfo
                data={data}
                handleChangeInput={this.handleChange}
                handleChangeDropdown={this.handleChangeDropdown}
                viewMode={this.state.viewMode}
                deleted={Boolean(data && data.DELETED)}
                people={this.state.people}
                peopleBusy={this.state.peopleBusy}
                peopleError={this.state.peopleError}
              />
            ),
          },
        ]}
        backLink={`${arc.path.base}firms`}
        edit={edit}
        state={this.state}
        setState={this.setState.bind(this)}
        handleSubmit={this.handleSubmit}
        saveData={this.saveData}
        type="firm"
        backName="FIRMS"
        title={data && `${data.NAME}`}
        /* Edit and Delete for whoever edits every SUMMIT record (the old admin rule). */
        forceActions={editsEverySummitRecord(getCurrentAccess())}
      />
    );
  }
}
